import React, { Component } from 'react'
import CardHeader from '../component/card/cardHeader';
import StudentInfoBtn from '../component/header/studentInfoBtn/studentInfoBtn';
import Time from '../component/header/time/time';
import InfoTable from '../component/studentInfo/infoTable';
import StudentInfo from '../component/studentInfo/studentInfo';
import './style_login.css';
import { BrowserRouter as Router,Route,Link } from 'react-router-dom';


export default class Login extends Component {
    constructor(props){
        super(props);
        console.log(props);
        console.log(props.match.params.sit);
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
          };
          var jresult = JSON.parse("{}");  
          this.state= {
            examcode :"",
            birthdate :"",
            test_name :"",
            mb_id :"",
            mb_name :"",
            sit : props.match.params.sit,
            mb_birth  :""
           };          
          fetch("http://118.39.27.87:8080/users/sit?id="+props.match.params.sit, requestOptions)
            .then(response => response.text())
            .then(result => {console.log(result);
                            jresult = JSON.parse(result);
                            console.log(jresult);
                        this.setState({
                            mb_id :jresult[0]["mb_id"],
                            test_name :jresult[0]["test_name"],
                            mb_id :jresult[0]["mb_id"],
                            mb_name :jresult[0]["mb_name"], 
                            mb_birth  :jresult[0]["mb_birth"]                           
                        } );
                        localStorage.clear();                        
                        localStorage.setItem("userInfo",result);          
                        })
                      
            .catch(error => console.log('error !', error));

               console.log("test"+this.state);                

    }
    handleExamcode = e =>{
        this.setState({
            examcode : e.target.value
        });
    };
    handleBirthdate = e => {
        this.setState({
            birthdate : e.target.value
        });
    };
  
  handleSubmit = e =>{
       e.preventDefault();

    console.log("The form was submitted with the following data:");
    console.log(this.state);
    // window.open("/guides");
     window.location="/guide01";
  }
    render() {
       // const sit = props.match.params.sit;
        return (
            <div className="login-wrap wrap d-flex flex-column">
                <header className="d-flex align-items-center justify-content-between">
                    <div className="d-flex flex-grow-1 align-items-center justify-content-between">
                        <StudentInfoBtn Sitnum={this.state.sit} mb_id={this.state.mb_id} mb_name={this.state.mb_name} test_name={this.state.test_name} test_sec={this.state.test_sec} onOpen={this.props.onOpen} />
                        <div className="d-flex align-items-center right"><Time /></div>
                    </div>
                </header>
                <StudentInfo mb_birth ={this.state.mb_birth} Sitnum={this.state.sit} mb_id={this.state.mb_id} mb_name={this.state.mb_name} test_sec={this.state.test_sec} test_name={this.state.test_name} currentClass={this.props.currentClass} onClose={this.props.onClose} />
    
                <form className="formFields" onSubmit={this.handleSubmit}>  
                    <section className="login-wrap main-container d-flex justify-content-center align-items-center scroll-wrapper main-bg">
                    
                        <ul className="card-container d-flex flex-column position-relative p-0 m-0">
                            <CardHeader pageTitles={this.props.pageTitles} mb_birth ={this.state.mb_birth} Sitnum={this.state.sit} mb_id={this.state.mb_id}
                             mb_name={this.state.mb_name} test_name={this.state.test_name} />
                            <li className="card-body d-flex flex-column align-items-end scroll-wrapper">
                                <div className="warning main-bg w-100">
                                    <p className="text-center m-0">“감독관이 입실할 때까지 잠시 대기하여 주시기 바랍니다.”</p>
                                </div>
                                            
                                <div className="info-card table-wrap w-100">
                                    <InfoTable Sitnum={this.state.sit} mb_id={this.state.mb_id} mb_name={this.state.mb_name} test_sec={this.state.test_sec} test_name={this.state.test_name} onExamcode={this.handleExamcode} onBirthdate={this.handleBirthdate} />
                                    <p className="bottom-warning p-0">
                                        ※ 교시인증번호는 감독관이 각 교시 시작 전 별도로 안내할 예정입니다.<br/>
                                        ※ 생년월일 6자리를 입력해 주세요. 예) 901010<br/>
                                        ※ 위 시험정보와 응시자 정보를 확인하시고 교시인증번호와 생년월일을 입력하여 로그인해 주세요.
                                    </p>
                                </div>
                                                        
                            </li>
                            {/*로그인 버튼 */}
                            {/* <Link to={"/guide01"}><button type="submit" className="btn main-btn select-btn fail-btn">로그인</button></Link> */}
                            <li className="card-footer d-flex justify-content-center align-items-center"><Link to={"/guide01"}><button type="submit" className="btn main-btn login-btn">로그인</button></Link></li>
                        </ul>
                        
                    </section>
                </form>
           </div>
        )
    }
}
